export default __webpack_public_path__ + "a572f09681403aa4a2dc69d7d8d9a112.svg";